<template>
  <div class="page">
    <div class="page__wrap">
      <PromoHeader v-if="isUserInProject" />
      <PageIntro :isGameDownload="isGameDownload" @startDownload="onStartDownload" />
      <PageAbout @click="openPopup" />
      <PageFeaturesSlider />
      <PageJoin :isGameDownload="isGameDownload" @startDownload="onStartDownload" />

      <PopupVideo :isOpened="isPopupOpened" videoId="HWgJJDU7hhE" @popupClose="closePopup" />

      <TheFooter :linkItems="$t('footer.docs')" :pegi="$t('footer.pegi')" />
    </div>
  </div>
</template>

<script>
import PromoHeader from "@static_promo_pages/common/components/redesign/promo-header/vue/PromoHeader.vue";
import TheFooter from "@static_promo_pages/common/components/redesign/the-footer/vue/TheFooter.vue";
import PopupVideo from "@static_promo_pages/common/components/redesign/popups/vue/PopupVideo.vue";

import PageIntro from "@/components/page-intro/vue/PageIntro.vue";
import PageAbout from "@/components/page-about/vue/PageAbout.vue";
import PageJoin from "@/components/page-join/vue/PageJoin.vue";
import PageFeaturesSlider from "@/components/page-features/vue/PageFeaturesSlider.vue";

import UserMixin from "@godweb/frontend-base/src/mixins/user/UserMixin";

export default {
  name: "ThePage",
  components: {
    PromoHeader,
    TheFooter,
    PageIntro,
    PageAbout,
    PopupVideo,
    PageJoin,
    PageFeaturesSlider,
  },
  mixins: [UserMixin],
  data() {
    return {
      isPopupOpened: false,
      isGameDownload: false,
    };
  },
  created() {
    document.addEventListener("init_vue_components", this.initPromo);
  },
  mounted() {
    this.$oneLinkEventSender.sendEvent("visit");
  },
  methods: {
    async initPromo() {
      await this.$store.dispatch("global/auth", { profile_fields: ["registration_url"] });
    },
    openPopup() {
      this.isPopupOpened = true;
    },
    closePopup() {
      this.isPopupOpened = false;
    },
    onStartDownload() {
      this.isGameDownload = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/the-page";
</style>
